// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.lpu-capture-table > thead > tr.header-row > th {
  font: bold 11px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #424242;
  background-color: #FFF;
  top: 0;
  position: sticky;
}

table.lpu-capture-table > thead > tr.header-row > th.fixed {
  left: 0;
  z-index: 2;
}

table.lpu-capture-table > thead > tr.header-row > th:first-child {
  border-top-left-radius: 4px;
}

table.lpu-capture-table > thead > tr.header-row > th:last-child {
  border-top-right-radius: 4px;
}

table.lpu-capture-table > thead > tr.header-row > th:nth-child(n+3) {
  border-left: 1px #A0A0A0 solid;
  border-bottom: 1px #A0A0A0 solid;
}

table.lpu-capture-table > thead > tr.header-row > th.waypoint {
  background-color: #2c9fa2;
  border-bottom: 1px #FFF solid;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.lpu-capture-table > thead > tr.header-row > th.pole {
  background-color: #61b2b5;
  border-bottom: 1px #FFF solid;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.lpu-capture-table > thead > tr.header-row > th.account {
  background-color: #91c1c3;
  border-bottom: 1px #FFF solid;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.lpu-capture-table > thead > tr.header-row > th.invoice-total {
  background-color: #92c46d;
  color: #FFF;
  border-left: none;
  border-bottom: none;
}

table.lpu-capture-table > tbody > tr.data-row > td.payment-due-date {
  min-width: 100px;
}

.no-underline .MuiInput-underline:before {
  border-bottom: none !important;
}

.no-underline .MuiInput-underline:after {
  border-bottom: none !important;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(even) {
  font: bold 11px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #424242;
  background-color: #f4f4f4;
}

table.lpu-capture-table > tbody > tr.data-row > td {
  border-bottom: none;
}

table.lpu-capture-table > tbody > tr.data-row > td.fixed {
  position: sticky;
  left: 0px;
}

table.lpu-capture-table > tbody > tr.data-row > td:nth-child(n+3),
table.lpu-capture-table > tbody.invoice.multi > tr.data-row:nth-child(n+1) > td {
  font: bold 12px/15px Roboto;
  border-left: 1px #A0A0A0 solid;
}

table.lpu-capture-table > tbody > tr.data-row > td.waypoint {
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(even) > td.waypoint {
  background-color: #2a989c;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(odd) > td.waypoint {
  background-color: #2c9fa2;
}

table.lpu-capture-table > tbody > tr.data-row > td.pole {
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(even) > td.pole {
  background-color: #5daaad;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(odd) > td.pole {
  background-color: #61b2b5;
}

table.lpu-capture-table > tbody > tr.data-row > td.account {
  background-color: #8cb8ba;
  border-right: 1px #FFF solid;
  color: #FFF;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(even) > td.account {
  background-color: #8cb8ba;
}

table.lpu-capture-table > tbody > tr.data-row:nth-child(odd) > td.account {
  background-color: #91c1c3;
}

table.lpu-capture-table > tbody > tr.data-row.multi:nth-child(even) {
  background-color: #d2e788;
}

table.lpu-capture-table > tbody > tr.data-row.multi:nth-child(odd) {
  background-color: #c5e369;
}

table.lpu-capture-table > tbody.invoice.multi > tr:nth-child(1) > td {
  border-top: 1px #A0A0A0 solid;
}

table.lpu-capture-table > tbody.invoice.multi > tr:nth-child(1) > td:nth-child(-n+3) {
  border-top-color: white;
}

table.lpu-capture-table > tbody > tr.data-row input {
  width: 100%;
  flex: 1;
  text-align: left;
  font: 700 12px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
  border: none;
  background-color: transparent;
  padding: 0px;
  cursor: text !important;
}

table.lpu-capture-table > tbody > tr.data-row input:focus {
  outline: none;
  border-bottom: 1px solid;
  margin-bottom: -1px;
}

table.lpu-capture-table > tbody > tr.data-row input::-webkit-outer-spin-button,
table.lpu-capture-table > tbody > tr.data-row input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
table.lpu-capture-table > tbody > tr.data-row input[type=number] {
  -moz-appearance: textfield;
}

table.lpu-capture-table > tbody > tr.data-row.Mui-selected:nth-child(odd) > td {
  color: #FFF;
  background-color: #91c1c3;
}

table.lpu-capture-table > tbody > tr.data-row.Mui-selected:nth-child(even) > td {
  color: #FFF;
  background-color: #8cb8ba;
}

table.lpu-capture-table > tbody > tr.data-row.Mui-selected > td > input {
  color: #FFF;
}

table.lpu-capture-table > tbody > tr.data-row > td.disabled,
table.lpu-capture-table > tbody > tr.data-row > td > input:disabled {
  color: #7e7e7e;
}`, "",{"version":3,"sources":["webpack://./src/style/transformer/LPUCapturing.scss"],"names":[],"mappings":"AAYA;EACI,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,MAAA;EACA,gBAAA;AAXJ;;AAcA;EACI,OAAA;EACA,UAAA;AAXJ;;AAcA;EACI,2BAAA;AAXJ;;AAcA;EACI,4BAAA;AAXJ;;AAcA;EACI,8BAAA;EACA,gCAAA;AAXJ;;AAcA;EACI,yBAxCa;EAyCb,6BAAA;EACA,4BAAA;EACA,WAAA;AAXJ;;AAaA;EACI,yBA7CS;EA8CT,6BAAA;EACA,4BAAA;EACA,WAAA;AAVJ;;AAYA;EACI,yBAlDY;EAmDZ,6BAAA;EACA,4BAAA;EACA,WAAA;AATJ;;AAWA;EACI,yBAjDkB;EAkDlB,WAAA;EACA,iBAAA;EACA,mBAAA;AARJ;;AAWA;EACI,gBAAA;AARJ;;AAWA;EACI,8BAAA;AARJ;;AAWA;EACI,8BAAA;AARJ;;AAWA;EACI,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAxEa;AAgEjB;;AAWA;EACI,mBAAA;AARJ;;AAWA;EACI,gBAAA;EACA,SAAA;AARJ;;AAWA;;EAEI,2BAAA;EACA,8BAAA;AARJ;;AAWA;EACI,4BAAA;EACA,WAAA;AARJ;;AAWA;EACI,yBArGkB;AA6FtB;;AAWA;EACI,yBA5Ga;AAoGjB;;AAWA;EACI,4BAAA;EACA,WAAA;AARJ;;AAWA;EACI,yBAjHc;AAyGlB;;AAWA;EACI,yBAxHS;AAgHb;;AAWA;EACI,yBAxHiB;EAyHjB,4BAAA;EACA,WAAA;AARJ;;AAWA;EACI,yBA9HiB;AAsHrB;;AAWA;EACI,yBArIY;AA6HhB;;AAWA;EACI,yBApIa;AA4HjB;;AAWA;EACI,yBAzIa;AAiIjB;;AAWA;EACI,6BAAA;AARJ;;AAWA;EACI,uBAAA;AARJ;;AAWA;EACI,WAAA;EACA,OAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EAEA,YAAA;EACA,6BAAA;EACA,YAAA;EAEA,uBAAA;AAVJ;;AAYA;EACI,aAAA;EACA,wBAAA;EACA,mBAAA;AATJ;;AAYA;;EAEE,wBAAA;EACA,SAAA;AATF;;AAYA,YAAA;AACA;EACE,0BAAA;AATF;;AAYA;EACI,WAAA;EACA,yBAzLY;AAgLhB;;AAYA;EACI,WAAA;EACA,yBA3LiB;AAkLrB;;AAYA;EACI,WAAA;AATJ;;AAYA;;EAEI,cAAA;AATJ","sourcesContent":["$COLOR_WAYPOINT: get('colors.table.capturing.lpu.waypoint');\n$COLOR_POLE: get('colors.table.capturing.lpu.pole');\n$COLOR_ACCOUNT: get('colors.table.capturing.lpu.account');\n$COLOR_WAYPOINT_EVEN: get('colors.table.capturing.lpu.waypointEven');\n$COLOR_POLE_EVEN: get('colors.table.capturing.lpu.poleEven');\n$COLOR_ACCOUNT_EVEN: get('colors.table.capturing.lpu.accountEven');\n$COLOR_OLD_RATE: get('colors.table.capturing.lpu.oldRate');\n$COLOR_NEW_RATE: get('colors.table.capturing.lpu.newRate');\n$COLOR_EVEN_ROW: get('colors.table.capturing.lpu.evenRow');\n$COLOR_TOTAL_INVOICE: get('colors.table.capturing.lpu.invoiceTotal');\n$COLOR_TOTAL_INVOICE_EVEN: get('colors.table.capturing.lpu.invoiceTotalEven');\n\ntable.lpu-capture-table > thead > tr.header-row > th {\n    font: bold 11px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #424242;\n    background-color: #FFF;\n    top: 0;\n    position: sticky;\n}\n\ntable.lpu-capture-table > thead > tr.header-row > th.fixed {\n    left: 0;\n    z-index: 2;\n}\n\ntable.lpu-capture-table > thead > tr.header-row > th:first-child {\n    border-top-left-radius: 4px;\n}\n\ntable.lpu-capture-table > thead > tr.header-row > th:last-child {\n    border-top-right-radius: 4px;\n}\n\ntable.lpu-capture-table > thead > tr.header-row > th:nth-child(n + 3) {\n    border-left: 1px #A0A0A0 solid;\n    border-bottom: 1px #A0A0A0 solid;\n}\n\ntable.lpu-capture-table > thead > tr.header-row > th.waypoint {\n    background-color: $COLOR_WAYPOINT;\n    border-bottom: 1px #FFF solid;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\ntable.lpu-capture-table > thead > tr.header-row > th.pole {\n    background-color: $COLOR_POLE;\n    border-bottom: 1px #FFF solid;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\ntable.lpu-capture-table > thead > tr.header-row > th.account {\n    background-color: $COLOR_ACCOUNT;\n    border-bottom: 1px #FFF solid;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\ntable.lpu-capture-table > thead > tr.header-row > th.invoice-total {\n    background-color: $COLOR_TOTAL_INVOICE;\n    color: #FFF;\n    border-left: none;\n    border-bottom: none;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.payment-due-date {\n    min-width: 100px;\n}\n\n.no-underline .MuiInput-underline:before {\n    border-bottom: none !important;\n}\n\n.no-underline .MuiInput-underline:after {\n    border-bottom: none !important;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(even) {\n    font: bold 11px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #424242;\n    background-color: $COLOR_EVEN_ROW;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td {\n    border-bottom: none;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.fixed {\n    position: sticky;\n    left: 0px;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td:nth-child(n + 3),\ntable.lpu-capture-table > tbody.invoice.multi > tr.data-row:nth-child(n + 1) > td {\n    font: bold 12px/15px Roboto;\n    border-left: 1px #A0A0A0 solid;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.waypoint {\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(even) > td.waypoint {\n    background-color: $COLOR_WAYPOINT_EVEN;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(odd) > td.waypoint {\n    background-color: $COLOR_WAYPOINT;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.pole {\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(even) > td.pole {\n    background-color: $COLOR_POLE_EVEN;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(odd) > td.pole {\n    background-color: $COLOR_POLE;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.account {\n    background-color: $COLOR_ACCOUNT_EVEN;\n    border-right: 1px #FFF solid;\n    color: #FFF;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(even) > td.account {\n    background-color: $COLOR_ACCOUNT_EVEN;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row:nth-child(odd) > td.account {\n    background-color: $COLOR_ACCOUNT;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row.multi:nth-child(even) {\n    background-color: $COLOR_NEW_RATE;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row.multi:nth-child(odd) {\n    background-color: $COLOR_OLD_RATE;\n}\n\ntable.lpu-capture-table > tbody.invoice.multi > tr:nth-child(1) > td {\n    border-top: 1px #A0A0A0 solid;\n}\n\ntable.lpu-capture-table > tbody.invoice.multi > tr:nth-child(1) > td:nth-child(-n+3) {\n    border-top-color: white;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row input {\n    width: 100%;\n    flex: 1;\n    text-align: left;\n    font: 700 12px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n\n    border: none;\n    background-color: transparent;\n    padding: 0px;\n\n    cursor: text !important;\n}\ntable.lpu-capture-table > tbody > tr.data-row input:focus {\n    outline: none;    \n    border-bottom: 1px solid;\n    margin-bottom: -1px;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row input::-webkit-outer-spin-button,\ntable.lpu-capture-table > tbody > tr.data-row input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ntable.lpu-capture-table > tbody > tr.data-row input[type=number] {\n  -moz-appearance: textfield;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row.Mui-selected:nth-child(odd) > td {\n    color: #FFF;\n    background-color: $COLOR_ACCOUNT;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row.Mui-selected:nth-child(even) > td {\n    color: #FFF;\n    background-color: $COLOR_ACCOUNT_EVEN;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row.Mui-selected > td > input {\n    color: #FFF;\n}\n\ntable.lpu-capture-table > tbody > tr.data-row > td.disabled,\ntable.lpu-capture-table > tbody > tr.data-row > td > input:disabled {\n    color: #7e7e7e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
